import { InjectionToken } from '@angular/core';
import Big from 'big.js';

export interface AmountInputConfig {
  thousandSeparator: string;
  decimalSeparator: string;
  maxIntegerDigits: number;
  maxDecimalDigits: number;
  allowNegative: boolean;
}

export const AMOUNT_INPUT_CONFIG = new InjectionToken<AmountInputConfig>(
  'AMOUNT_INPUT_CONFIG',
  {
    providedIn: 'root',
    factory: () => {
      Big.RM = Big.roundDown;
      return {
        thousandSeparator: ',',
        decimalSeparator: '.',
        maxIntegerDigits: 15,
        maxDecimalDigits: 8,
        allowNegative: false,
      };
    },
  },
);
